import React, { createContext, useContext, useMemo } from "react";

type BreakdownStaleContextValue = {
  registerPaymentPlanBreakdownStale: (planId: string, stale: boolean) => void;
  registerServiceChargeBreakdownStale: (planId: string, stale: boolean) => void;
  assertNoStaleCommercialBreakdowns: () => boolean;
};

const BreakdownStaleContext = createContext<BreakdownStaleContextValue | null>(null);

type BreakdownStaleProviderProps = BreakdownStaleContextValue & {
  children: React.ReactNode;
};

export const BreakdownStaleProvider = (props: BreakdownStaleProviderProps) => {
  const {
    registerPaymentPlanBreakdownStale,
    registerServiceChargeBreakdownStale,
    assertNoStaleCommercialBreakdowns,
    children,
  } = props;

  const value = useMemo(
    () => ({
      registerPaymentPlanBreakdownStale,
      registerServiceChargeBreakdownStale,
      assertNoStaleCommercialBreakdowns,
    }),
    [registerPaymentPlanBreakdownStale, registerServiceChargeBreakdownStale, assertNoStaleCommercialBreakdowns],
  );

  return <BreakdownStaleContext.Provider value={value}>{children}</BreakdownStaleContext.Provider>;
};

export function useBreakdownStaleContext(): BreakdownStaleContextValue {
  const context = useContext(BreakdownStaleContext);

  if (!context) throw new Error("useBreakdownStaleContext must be used within a BreakdownStaleProvider");

  return context;
}
